module.exports = __webpack_public_path__ + "img/close-grey.40b05fa9.svg";